const config = require('./config')
const axios = require('axios')
const _ = require('underscore')

const headers = {
    'X-Parse-Application-Id': config.appId,
    'X-Parse-REST-API-Key': config.apiKey
}

export default function request(url, options) {

    if (url === 'login') {
        _.extend(headers, {
            'X-Parse-Master-Key': config.masterKey,
            'X-Parse-Revocable-Session': 1
        });

        return new Promise((resolve, reject) => { 
            axios({
                url: config.api + url,
                method: 'GET',
                headers: headers,
                params: options.data,
            }).then((resp) => {
                resolve(resp.data)
            }).catch((e) => {
                reject(e.response)
            });
        });

    } else if (url === 'logout') {
        _.extend(headers, {
            'X-Parse-Session-Token': options.sessionToken
        });

        return new Promise((resolve, reject) => { 
            axios({
                url: config.api + url,
                method: 'POST',
                headers: headers,
            }).then((resp) => {
                resolve(resp.data)
            }).catch((e) => {
                reject(e.response)
            });
        });

    } else if (url === 'batch') {
        _.extend(headers, {
            'X-Parse-Master-Key': config.masterKey,
        });

        return new Promise((resolve, reject) => { 
            axios({
                url: config.api + url,
                method: 'POST',
                headers: headers,
                data: options.data
            }).then((resp) => {
                resolve(resp.data)
            }).catch((e) => {
                reject(e.response)
            });
        });

    } else if (options.type === 'batchObject') {
        _.extend(options.data, {
            _ApplicationId: config.appId,
            _MasterKey: config.masterKey,
            _method: options.method
        });

        return new Promise((resolve, reject) => { 
            axios({
                url: config.api + 'classes/' + url,
                method: 'POST',
                data: options.data
            }).then((resp) => {
                resolve(resp.data)
            }).catch((e) => {
                reject(e.response)
            });
        });

    } else {
        
        const data = {
            url: config.api + 'classes/' + url,
            method: options.method || 'GET',
            headers: headers,
        }

        if (options.method === 'GET') {
            // GET ALL or GET Specific
            options.data ? _.extend(data, {params: options.data}) : null;

        } else {
            // POST or PUT
            _.extend(data, {data: options.data || {}})
        }

        return new Promise((resolve, reject) => { 
            axios(data).then((resp) => {
                resolve(resp.data)
            }).catch((e) => {
                reject(e.response)
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/utils/request.js